import React from "react";
import {
  CardHeader as MuiCardHeader,
  CardHeaderProps as MuiCardHeaderProps,
  colors,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CardHeaderTitle from "./card-header-title.component";

interface CardHeaderProps extends Omit<MuiCardHeaderProps, "title"> {
  title?: React.ReactNode;
  icon?: React.ReactNode;
  divider?: boolean;
  center?: boolean;
}

const StyledCardHeader = styled(MuiCardHeader)(() => ({
  backgroundColor: colors.grey[50],
}));

const CardHeader = React.forwardRef<HTMLDivElement, CardHeaderProps>(
  ({ divider = true, center = false, title, icon, ...props }, ref) => {
    const customTitle =
      title || icon ? (
        <CardHeaderTitle title={title} icon={icon} center={center} />
      ) : undefined;

    return (
      <>
        <StyledCardHeader ref={ref} title={customTitle} {...props} />
        {divider && <Divider />}
      </>
    );
  }
);

CardHeader.displayName = "CardHeader";

export default CardHeader;
